import React, { memo } from 'react';
export var Considered = /*#__PURE__*/memo(function (_ref) {
  var _ref$primaryColor = _ref.primaryColor,
      primaryColor = _ref$primaryColor === void 0 ? '#6AABB8' : _ref$primaryColor,
      _ref$secondaryColor = _ref.secondaryColor,
      secondaryColor = _ref$secondaryColor === void 0 ? '#FFA06A' : _ref$secondaryColor,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 42 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 42 : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 42",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2---MBP-CatPg-",
    transform: "translate(-870.000000, -2453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-3---How-we-Decided",
    transform: "translate(360.000000, 2360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "How-we-Decided"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-3---How-we-Decided"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stat-1",
    transform: "translate(510.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_considered",
    transform: "translate(0.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8559994,37.5439982 L3.95199981,37.5439982 C1.77247191,37.5439982 0,35.7715262 0,33.5919983 L0,3.95199981 C0,1.77444791 1.77247191,0 3.95199981,0 L33.5919983,0 C35.7715262,0 37.5439982,1.77444791 37.5439982,3.95199981 L37.5439982,11.8559994 L33.5919983,11.8559994 L33.5919983,3.95199981 L3.95199981,3.95199981 L3.95199981,33.5919983 L11.8559994,33.5919983 L11.8559994,37.5439982 Z",
    id: "Fill-1642",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7839991,25.6879987 C17.7839991,21.328943 21.328943,17.7839991 25.6879987,17.7839991 C30.0470545,17.7839991 33.5919983,21.328943 33.5919983,25.6879987 C33.5919983,30.0470545 30.0470545,33.5919983 25.6879987,33.5919983 C21.328943,33.5919983 17.7839991,30.0470545 17.7839991,25.6879987 L17.7839991,25.6879987 Z M41.9050299,39.1109661 L35.3407583,32.5466944 C36.7219822,30.6102145 37.5439982,28.2449426 37.5439982,25.6879987 C37.5439982,19.1494151 32.2265824,13.8319993 25.6879987,13.8319993 C19.1494151,13.8319993 13.8319993,19.1494151 13.8319993,25.6879987 C13.8319993,32.2265824 19.1494151,37.5439982 25.6879987,37.5439982 C28.2449426,37.5439982 30.6082385,36.7219822 32.5466944,35.3407583 L39.1109661,41.9050299 L41.9050299,39.1109661 Z",
    id: "Fill-1644",
    fill: secondaryColor
  }))))))))));
});